<script>
export default {
  props: {
    module: Object,
    span: {
      default: 6,
    },
  },
  methods: {
    handlerChange() {
      if (this.module.payer === 'agency') {
        this.module.type = 'preorder';
      }
    },
  },
};
</script>
<template>
  <ColGroup
    label="Бронировать как"
    :span="span"
    class="p-t-c-itt"
  >
    <el-radio-group
      v-model="module.payer"
      @change="handlerChange"
    >
      <el-radio-button label="client">Клиент</el-radio-button>
      <el-radio-button label="agency">Агентство</el-radio-button>
    </el-radio-group>
  </ColGroup>
</template>
<style lang="scss">
  .p-t-c-itt {
    .el-radio-group {
      display: flex;
      margin: 8px;
    }

    .el-radio-button {
      width: 50%;
    }

    .el-radio-button__inner {
      width: 100%;
    }
  }
</style>
